import { capitalize, cleanLocation } from "@components/blocks/Jobs/JobCard";
import { colors } from "@components/Theme/colors";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Box, Button, Container, Grid, keyframes, Stack, Typography } from "@mui/material";
import { Image } from "components";
import NextLink from "next/link";
import { useRouter } from "next/router";
import { APITypes, ECluster } from "utils/api.types";
const spin = keyframes`
  from {
    height: 0px;
  }
`;
interface VacatureDetailHeroProps {
  block: APITypes.Components.ContentBlocks.VacatureDetail;
  position: APITypes.Components.Job;
}
export const getHeroImageForCluster = (cluster: string, block: APITypes.Components.ContentBlocks.VacatureDetail) => {
  let image;
  switch (cluster) {
    case ECluster.Consultants:
      image = block.heroImageConsult;
      break;
    case ECluster.IT:
      image = block.heroImageIT;
      break;
    case ECluster.Payroll:
      image = block.heroImagePayroll;
      break;
    case ECluster.SelfStarters:
      image = block.heroImageSelfStarters;
      break;
    default:
      image = block.heroImageConsult;
  }
  return image;
};
const VacatureDetailHero = ({
  block,
  position
}: VacatureDetailHeroProps) => {
  const router = useRouter();
  const location = position.location ? capitalize(cleanLocation(position.location)) : "";
  const image = getHeroImageForCluster(position.cluster, block);
  return <Box pt={{
    xs: 8,
    lg: 8
  }} sx={{
    backgroundColor: colors.greyColor.light,
    display: "flex",
    alignItems: "end"
  }} data-sentry-element="Box" data-sentry-component="VacatureDetailHero" data-sentry-source-file="VacatureDetailHero.tsx">
      <Container disableGutters data-sentry-element="Container" data-sentry-source-file="VacatureDetailHero.tsx">
        <Grid container alignItems="stretch" data-sentry-element="Grid" data-sentry-source-file="VacatureDetailHero.tsx">
          <Grid item xs={12} lg={6} sx={{
          display: "flex",
          flexDirection: "column",
          flex: 1
        }} data-sentry-element="Grid" data-sentry-source-file="VacatureDetailHero.tsx">
            <Stack justifyContent="center" height={"100%"} sx={{
            paddingLeft: {
              xs: "16px",
              md: "48px"
            }
          }} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailHero.tsx">
              <Stack pb={4} gap={4} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailHero.tsx">
                <Stack data-sentry-element="Stack" data-sentry-source-file="VacatureDetailHero.tsx">
                  <Typography component={"div"} sx={{
                  color: colors.green.main,
                  fontSize: {
                    lg: "20px",
                    xs: "16px"
                  },
                  fontWeight: 400
                }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailHero.tsx">
                    <Box sx={{
                    display: "flex",
                    alignItems: "center"
                  }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailHero.tsx">
                      <LocationOnIcon data-sentry-element="LocationOnIcon" data-sentry-source-file="VacatureDetailHero.tsx" />

                      {location}
                    </Box>
                  </Typography>
                  <Typography variant="h2" sx={{
                  color: colors.primary.main
                }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailHero.tsx">
                    {position.title}
                  </Typography>
                </Stack>
                <Stack gap={2} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailHero.tsx">
                  <Typography variant="h1" color="primary" data-sentry-element="Typography" data-sentry-source-file="VacatureDetailHero.tsx">
                    {position.subTitle}
                  </Typography>
                  <Typography component={"div"} sx={{
                  fontSize: {
                    lg: "16px",
                    xs: "16px"
                  },
                  fontWeight: 600,
                  maxWidth: {
                    xs: "100%",
                    md: "60%"
                  }
                }} data-sentry-element="Typography" data-sentry-source-file="VacatureDetailHero.tsx">
                    <Box sx={{
                    ["ul"]: {
                      paddingLeft: {
                        xs: "0",
                        sm: "40px"
                      }
                    },
                    "& li::marker": {
                      content: "'━'",
                      color: colors.secondary.main
                    },
                    "& li": {
                      pl: "10px",
                      pb: "10px"
                    }
                  }} dangerouslySetInnerHTML={{
                    __html: position.profileTop
                  }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailHero.tsx" />
                  </Typography>
                  {block.heroButton != null && <Stack direction="row" py={2}>
                      <Button component={NextLink} href={block.heroButton.href} variant="contained" size="large">
                        {block.heroButton.title}
                      </Button>
                    </Stack>}
                </Stack>
              </Stack>
            </Stack>
            <Stack direction={"row"} width={"100%"} alignItems={"end"} height={"81px"} sx={{
            display: {
              xs: "none",
              lg: "flex"
            }
          }} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailHero.tsx">
              <Box sx={{
              background: colors.primary.main,
              height: "81px",
              width: "100%",
              animation: `${spin} 0.5s ease`
            }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailHero.tsx" />
              <Box sx={{
              background: colors.green.main,
              height: "81px",
              width: "100%",
              animation: `${spin} 0.5s ease`
            }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailHero.tsx" />
              <Box sx={{
              background: colors.secondary.main,
              height: "40px",
              width: "100%",
              animation: `${spin} 0.5s ease`
            }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailHero.tsx" />
            </Stack>
          </Grid>
          <Grid item xs={12} lg={6} data-sentry-element="Grid" data-sentry-source-file="VacatureDetailHero.tsx">
            <Stack direction={"row"} alignItems={"end"} sx={{
            height: "100%",
            minHeight: {
              xs: "100%",
              md: "498px"
            }
          }} data-sentry-element="Stack" data-sentry-source-file="VacatureDetailHero.tsx">
              <Image style={{
              objectFit: "cover",
              height: "100%",
              width: "100%",
              alignSelf: "stretch"
            }} image={image} alt={image.name} layout="responsive" data-sentry-element="Image" data-sentry-source-file="VacatureDetailHero.tsx" />
              <Box sx={{
              background: "#E14C8B",
              height: "300px",
              width: "60px",
              flexShrink: 0,
              animation: `${spin} 0.5s ease`,
              display: {
                xs: "none",
                lg: "flex"
              }
            }} data-sentry-element="Box" data-sentry-source-file="VacatureDetailHero.tsx" />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>;
};
export default VacatureDetailHero;